export interface PlatformInfo {
  ios: boolean;
  standalone: boolean;
  touch: boolean;
}

interface NavigatorLike {
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
  standalone?: boolean;
}

/** iPhone/iPad, inclusiv iPadOS care se prezintă ca „Macintosh”. */
export function detectPlatform(nav: NavigatorLike, displayStandalone: boolean): PlatformInfo {
  const ua = nav.userAgent || '';
  const touch = (nav.maxTouchPoints || 0) > 0;
  const ios = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && (nav.maxTouchPoints || 0) > 1);
  const standalone = nav.standalone === true || displayStandalone;
  return { ios, standalone, touch };
}

/** Instrucțiunile de instalare apar doar în Safari normal pe iOS, nu în aplicația instalată. */
export function shouldShowInstallHint(p: PlatformInfo, dismissed: boolean): boolean {
  return p.ios && !p.standalone && !dismissed;
}

/** Test minim de WASM SIMD: un modul care folosește i8x16.splat trebuie să fie valid. */
export const SIMD_PROBE = new Uint8Array([
  0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11
]);

export function wasmSimdSupported(): boolean {
  try {
    return typeof WebAssembly === 'object' && WebAssembly.validate(SIMD_PROBE);
  } catch {
    return false;
  }
}
